export * from 'utils/math.js';

export function randomInteger(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}